module.exports = function() {
    return {
        id: null,
        project_id: null,
        title: "",
        description: "",
        story_id: null
    }
}